import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contratoAnualizadoApi } from "@/features/seleccionar-contrato-anualizado/services/contrato-anualizado.api";
import { qk } from "@/lib/query-keys";
import { toastError, toastExito } from "@/lib/toast";
import { extractApiMessage } from "@/shared/api/extract-message";

/**
 * Mutation para asociar el contrato anualizado (CA) · al éxito hidrata el cache de
 * la solicitud (el backend devolvió el detalle con `contratoAnualizado` poblado y
 * estado `ContratoAnualizadoSeleccionado`). La navegación queda a cargo del caller.
 */
export function useSeleccionarContratoAnualizado(
  solicitudId: string,
  options?: { onSuccess?: () => void }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (clave: string) => contratoAnualizadoApi.seleccionar(solicitudId, clave),
    onSuccess: (solicitud) => {
      qc.setQueryData(qk.solicitud(solicitudId), solicitud);
      toastExito({ title: "Contrato asociado", message: `Contrato ${solicitud.contratoAnualizado?.clave ?? ""} · continúa con la carga del CFDI.` });
      options?.onSuccess?.();
    },
    onError: (e) => toastError({ title: "No se pudo asociar el contrato", message: extractApiMessage(e, "Revisa la clave del contrato.") }),
  });
}
